import { Component, OnInit } from '@angular/core';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';

import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { FirmlyApprovedService } from '../../../shared/services/firmly-approved/firmly-approved.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import {
  EVENT as EVENT_FA_LD,
  PAGEVIEW as PAGEVIEW_FA_LD,
  CHANNEL as CHANNEL_FA_LD,
  COUNTRY as COUNTRY_FA_LD,
  BUSINNESS as BUSINNESS_FA_LD,
  ENVIRONMENT as ENVIRONMENT_FA_LD,
  FAMILY as FAMILY_FA_LD,
  SUBFAMILY as SUBFAMILY_FA_LD,
  PRODUCT as PRODUCT_FA_LD,
} from 'src/app/shared/constants/dali-fa-ld.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

@Component({
  selector: 'app-opening-savings-account',
  templateUrl: './opening-savings-account.component.html',
  styleUrls: ['./opening-savings-account.component.scss'],
})
export class OpeningSavingsAccountComponent implements OnInit {

  screenCopies: any;
  productSelected: any;

  constructor(
    public copyService: CopyService,
    private bitacoraService: BitacoraService,
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private firmlyApprovedService: FirmlyApprovedService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private daliService: DaliService,
    private taggingServices: TaggingService,
  ) {
    this.headerService.show(true, true, true);

  }

  ngOnInit() {
    this.sendTagging('init');
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendOpeningSavingsPageLoad();
    }
    this.productSelected = this.abreCuentasService.getproductSelected();
    this.abreCuentasService.setReceiveCard('2');
    this.copies();
  }

  copies() {
    if (this.abreCuentasService.haveLoan) {
      this.screenCopies = this.copyService.copies.opening_account_Multi;
    } else {
      this.regularScreenCopies();
    }
  }

  regularScreenCopies() {
    if (!this.abreCuentasService.viewOptionMultiProduct) {
      this.screenCopies = this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ? this.copyService.copies.opening_account_CRP : this.copyService.copies.opening_account_ORD;
    } else {
      if (this.abreCuentasService.getProductsSelects().length == 1) {
        this.screenCopies = this.abreCuentasService.getProductsSelects()[0].product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ? this.copyService.copies.opening_account_CRP : this.copyService.copies.opening_account_ORD;
      } else if (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
        this.screenCopies = this.copyService.copies.opening_account_multi_firmly_approved;
      } else {
        this.screenCopies = this.copyService.copies.opening_account_Multi;
      }
    }
  }

  updateDisbursementInfo() {
    let disbursement = this.abreCuentasService.getDisbursementInfo();
    if (disbursement) {
      disbursement.forEach(Productos => {
        Productos.refund.forEach(method => {
          if (method.refund_method === BUSINESS_CONST.AC) {
            method.account = {
              account_id: '',
              account_type: this.abreCuentasService.getOutlaySelection() === BUSINESS_CONST.ITAU ? BUSINESS_CONST.AHO : '',
              account_subtype: this.abreCuentasService.getStatusCreate() ? this.copyService.copies.create_account : '',
            };
          }
        });
      });
      this.abreCuentasService.setDisbursementInfo(disbursement);
    }
  }

  /**
   * Summary Go to next Step
   */
  next() {
    this.sendTagging('next', 'bottom', '2');
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendAcceptButtonEvent();
    }
    this.updateDisbursementInfo();
    let bitacoraEvent = '';
    !this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme'
      ? bitacoraEvent = 'af_accepted_multi_aho'
      : bitacoraEvent = `account_acept_${this.productSelected.product_code}`;
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    if (!this.firmlyApprovedService.isEmpty()
        && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme'
        && this.abreCuentasService.viewOptionMultiProduct) {
      const creditCard = this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_TC)[0];
      if (creditCard) {
        this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
        return;
      }
      const freeInvestment = this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_FREE)[0];
      const revolvingCredit = this.firmlyApprovedService.getDetailProductsMulti(BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)[0];
      const productsFirmlyApproved: any[] = [];

      if (freeInvestment) {
        productsFirmlyApproved.push(freeInvestment);
      }
      if (revolvingCredit) {
        productsFirmlyApproved.push(revolvingCredit);
      }
      this.abreCuentasService.getPcoModel().granted_product_multi = productsFirmlyApproved;
      this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
    } else if (this.abreCuentasService.viewOptionMultiProduct) {
      this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
    } else {
      this.navigationService.nextStep('200');
    }
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendOpeningSavingsPageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA_LD.pv11pageName.path,
        value: `${isApp ? CHANNEL_FA_LD.superapp : CHANNEL_FA_LD.homeBanking}:${COUNTRY_FA_LD.co}:${BUSINNESS_FA_LD.pf}:${ENVIRONMENT_FA_LD.loggeado}:${FAMILY_FA_LD.services}:${SUBFAMILY_FA_LD.request}:${PRODUCT_FA_LD.request}:${PAGEVIEW_FA_LD.pv11pageName.value}`,
      },
      {
        path: PAGEVIEW_FA_LD.pv11pageFamily.path,
        value: PAGEVIEW_FA_LD.pv11pageFamily.value,
      },
      {
        path: PAGEVIEW_FA_LD.pv11subFamily.path,
        value: PAGEVIEW_FA_LD.pv11subFamily.value,
      },
      {
        path: PAGEVIEW_FA_LD.pv11pageAction.path,
        value: PAGEVIEW_FA_LD.pv11pageAction.value,
      },
      {
        path: PAGEVIEW_FA_LD.pv11pageid.path,
        value: OpeningSavingsAccountComponent.name,
      },
      {
        path: PAGEVIEW_FA_LD.pv11transactionName.path,
        value: `${PAGEVIEW_FA_LD.pv11transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA_LD.pv11transactionTransactionStep.path,
        value: PAGEVIEW_FA_LD.pv11transactionTransactionStep.value,
      },
    ];
    this.taggingServices.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* ------------------ Taggeo ------------------ */

  sendBackButtonEvent(): void {
    this.sendTagging('prev', 'bottom', '1');
    if (!this.taggingServices.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_LD.pv11E1setData.pv11E1transactionTransactionStep.path,
        value: EVENT_FA_LD.pv11E1setData.pv11E1transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv11E1setData.pv11E1transactionName.path,
        value: `${PAGEVIEW_FA_LD.pv11transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`,
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv11E1customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendAcceptButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_LD.pv11E2setData.pv11E2transactionTransactionStep.path,
        value: EVENT_FA_LD.pv11E2setData.pv11E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv11E2setData.pv11E2transactionName.path,
        value: `${PAGEVIEW_FA_LD.pv11transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`,
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv11E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendTagging(value: any, position?: string, event?: string) {
    const page = '16';
    const extras = {
      pageValue: 'OpeningSavingsAccount',
    };
    this.taggingServices.sendTaggValues(value, page, position, event, extras);
  }
}
